import { useState, useEffect } from "react";
import { images } from "../../constants";
import "./Navbar.scss";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

import { Link, NavLink, useLocation } from "react-router-dom";

const Nav = (props) => {
  const [expandSubNav, setExpandSubNav] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng")
  );

  const location = useLocation();

  const { t } = useTranslation();

  const tabMappings = [
    { keyword: "etihad", tab: "etihad" },
    { keyword: "mediaCenter", tab: "media" },
  ];

  useEffect(() => {
    if (!currentLang || currentLang === undefined || currentLang === null)
      setCurrentLang(localStorage.getItem("i18nextLng"));
    // console.log(currentLang + " >>>>>>>>>>> " + localStorage.getItem("i18nextLng"));
    document.body.dir = i18n.dir();
    const match = tabMappings.find((item) =>
      location.pathname.includes(item.keyword)
    );

    if (match) {
      setExpandSubNav(true);
      setActiveTab(match.tab);
    } else {
      setExpandSubNav(false);
      setActiveTab("");
    }
  }, [location, currentLang]);

  const subNav = {
    etihad: [
      {
        label: t("nav.ethad.about"),
        // "عن الاتحاد",
        image: images.aboutEtihad,
        path: "etihad/AboutEtihad",
      },
      {
        label: t("nav.ethad.chef"),
        image: images.ethiad_cardWhite,
        path: "etihad/Leader",
      },
      {
        label: t("nav.ethad.structure"),
        image: images.ethiad_orgWhite,
        path: "etihad/ManagerialStructure",
      },
      {
        label: t("nav.ethad.law"),
        image: images.profileWhite,
        path: "etihad/Law",
      },
    ],
    services: [
      // {
      //   label: t("nav.otherServices.nashet"),
      //   image: images.groupWhite,
      //   url: "https://nashtsport.com",
      // },
      {
        label: t("nav.otherServices.ahlia"),
        image: images.gearWhite,
        url: "https://admin.susfweb.com/login?lt=1",
      },
      {
        label: t("nav.otherServices.result"),
        image: images.statusWhite,
        url: "https://admin.susfweb.com/login?lt=3",
      },
      {
        label: t("nav.otherServices.competition"),
        image: images.trophyWhite,
        url: "https://admin.susfweb.com/login?lt=2",
      },
      // {
      //   label: t("nav.otherServices.tasks"),
      //   image: images.briefcaseWhite,
      //   url: "https://susftask.com",
      // },
      {
        label: t("nav.otherServices.email"),
        image: images.emailWhite,
        url: "https://outlook.office.com/owa/?realm=susfweb.com",
      },
    ],
    media: [
      {
        label: t("nav.news.news"),
        image: images.messageWhite,
        path: "mediaCenter/News",
      },
      {
        label: t("nav.news.events"),
        image: images.scissorWhite,
        path: "mediaCenter/Activities",
      },
      {
        label: t("nav.news.vidios"),
        image: images.mediaWhite,
        path: "mediaCenter/Videos",
      },
      {
        label: t("nav.news.images"),
        image: images.galleryWhite,
        path: "mediaCenter/Photos",
      },
      {
        label: t("nav.news.ads"),
        image: images.adsWhite,
        path: "mediaCenter/Advertisements",
      },
      {
        label: t("nav.news.media"),
        image: images.profileWhite,
        path: "mediaCenter/MediaFiles",
      },
      {
        label: t("nav.news.prints"),
        image: images.printerWhite,
        path: "mediaCenter/Prints",
      },
    ],
  };

  const toggleSubNav = (tab) => {
    if (expandSubNav === true) {
      if (activeTab === tab) {
        setActiveTab("");
        setExpandSubNav(false);
      } else {
        setActiveTab(tab);
      }
    } else {
      setActiveTab(tab);
      setExpandSubNav(true);
    }
  };

  const changeLanguage = () => {
    if (currentLang === "ar") {
      i18n.changeLanguage("en");
      //console.log("current is english", i18n.dir());
      localStorage.setItem("i18nextLng", "en");
    }
    if (currentLang === "en") {
      i18n.changeLanguage("ar");
      // console.log("current is arabic", i18n.dir());
      localStorage.setItem("i18nextLng", "ar");
    }
    setCurrentLang(localStorage.getItem("i18nextLng"));

    document.title = t("webTitle");
  };

  return (
    <div className="navbar-container">
      <div className="main-nav">
        <div className="nav__list-container">
          <nav className="navbar navbar-expand-lg">
            <div className="navbar-nav">
              <NavLink
                to={"/"}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <p className="nav-link">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="vuesax/linear/house-2">
                      <g id="vuesax/linear/house-2_2">
                        <g id="house-2">
                          <path
                            id="Vector"
                            d="M1.33337 15.1667H14.6667"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_2"
                            d="M1.96667 15.1667L2.00001 7.14668C2.00001 6.74001 2.19334 6.35338 2.51334 6.10005L7.18001 2.46671C7.66001 2.09337 8.33335 2.09337 8.82001 2.46671L13.4867 6.09338C13.8133 6.34671 14 6.73335 14 7.14668V15.1667"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_3"
                            d="M10.3333 7.83331H5.66663C5.11329 7.83331 4.66663 8.27998 4.66663 8.83331V15.1666H11.3333V8.83331C11.3333 8.27998 10.8866 7.83331 10.3333 7.83331Z"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_4"
                            d="M6.66663 11.3333V12.3333"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_5"
                            d="M7 5.5H9"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>

                  <span className="m-1  menu-text">{t("nav.main")} </span>
                </p>
              </NavLink>
              <p
                className={`nav-link ${location.pathname.includes("etihad") ? "activeRoute" : ""
                  } ${activeTab === "etihad" ? "active" : ""}`}
                onClick={() => toggleSubNav("etihad")}
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="vuesax/linear/status-up">
                    <g id="vuesax/linear/status-up_2">
                      <g id="status-up">
                        <path
                          id="Vector"
                          d="M4.58667 12.6V11.22"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          id="Vector_2"
                          d="M8 12.6V9.84003"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          id="Vector_3"
                          d="M11.4133 12.6V8.45331"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          id="Vector_4"
                          d="M11.4133 4.40002L11.1067 4.76002C9.40667 6.74669 7.12667 8.15336 4.58667 8.78669"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          id="Vector_5"
                          d="M9.45996 4.40002H11.4133V6.34669"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_6"
                          d="M6.00004 15.1666H10C13.3334 15.1666 14.6667 13.8333 14.6667 10.5V6.49998C14.6667 3.16665 13.3334 1.83331 10 1.83331H6.00004C2.66671 1.83331 1.33337 3.16665 1.33337 6.49998V10.5C1.33337 13.8333 2.66671 15.1666 6.00004 15.1666Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </g>
                  </g>
                </svg>

                <span className="m-1  menu-text">{t("nav.ethad.main")} </span>
              </p>
              <NavLink
                to={"/competitions"}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <p className="nav-link">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="vuesax/linear/cup">
                      <g id="vuesax/linear/cup_2">
                        <g id="cup">
                          <path
                            id="Vector"
                            d="M8.09998 11.5V12.9"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_2"
                            d="M4.76672 15.1667H11.4334V14.5C11.4334 13.7667 10.8334 13.1667 10.1001 13.1667H6.10006C5.36672 13.1667 4.76672 13.7667 4.76672 14.5V15.1667V15.1667Z"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                          />
                          <path
                            id="Vector_3"
                            d="M4.09998 15.1667H12.1"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_4"
                            d="M8.00004 11.1666C5.42004 11.1666 3.33337 9.07998 3.33337 6.49998V4.49998C3.33337 3.02665 4.52671 1.83331 6.00004 1.83331H10C11.4734 1.83331 12.6667 3.02665 12.6667 4.49998V6.49998C12.6667 9.07998 10.58 11.1666 8.00004 11.1666Z"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_5"
                            d="M3.64665 8.26669C3.14665 8.10669 2.70665 7.81336 2.35999 7.46669C1.75999 6.80002 1.35999 6.00002 1.35999 5.06669C1.35999 4.13336 2.09332 3.40002 3.02665 3.40002H3.45999C3.32665 3.70669 3.25999 4.04669 3.25999 4.40002V6.40002C3.25999 7.06669 3.39999 7.69336 3.64665 8.26669Z"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_6"
                            d="M12.3534 8.26669C12.8534 8.10669 13.2934 7.81336 13.6401 7.46669C14.2401 6.80002 14.6401 6.00002 14.6401 5.06669C14.6401 4.13336 13.9067 3.40002 12.9734 3.40002H12.5401C12.6734 3.70669 12.7401 4.04669 12.7401 4.40002V6.40002C12.7401 7.06669 12.6001 7.69336 12.3534 8.26669Z"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>

                  <span className="m-1  menu-text"> {t("nav.competion")}</span>
                </p>
              </NavLink>
              <p
                className={`nav-link ${activeTab === "services" ? "active" : ""
                  }`}
                onClick={() => {
                  toggleSubNav("services");
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    id="services-20px-svgrepo-com 1"
                    clipPath="url(#clip0_1_5799)"
                  >
                    <g id="Group">
                      <path
                        id="Vector"
                        d="M0.800049 15.2H4.00005V12H0.800049V15.2ZM6.40005 15.2H9.60005V12H6.40005V15.2ZM12 15.2H15.2V12H12V15.2ZM0.800049 9.59999H4.00005V6.39999H0.800049V9.59999ZM6.40005 9.59999H9.60005V6.39999H6.40005V9.59999ZM12 9.59999H15.2V6.39999H12V9.59999ZM0.800049 3.99999H4.00005V0.799988H0.800049V3.99999ZM6.40005 3.99999H9.60005V0.799988H6.40005V3.99999ZM12 0.799988V3.99999H15.2V0.799988H12Z"
                        fill="#647687"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_1_5799">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <span className="m-1  menu-text">{t("nav.otherServices.main")} </span>
              </p>
              <p
                className={`nav-link ${location.pathname.includes("mediaCenter") ? "activeRoute" : ""
                  } ${activeTab === "media" ? "active" : ""}`}
                onClick={() => {
                  toggleSubNav("media");
                }}
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="vuesax/linear/ranking">
                    <g id="vuesax/linear/ranking_2">
                      <g id="ranking">
                        <path
                          id="Vector"
                          d="M5.78004 9.83331H2.66671C1.93337 9.83331 1.33337 10.4333 1.33337 11.1666V15.1666H5.78004V9.83331Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_2"
                          d="M8.88665 7.16669H7.10665C6.37332 7.16669 5.77332 7.76669 5.77332 8.50002V15.1667H10.22V8.50002C10.22 7.76669 9.62665 7.16669 8.88665 7.16669Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_3"
                          d="M13.3333 11.8333H10.22V15.1666H14.6666V13.1666C14.6666 12.4333 14.0666 11.8333 13.3333 11.8333Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <g id="Group">
                          <path
                            id="Vector_4"
                            d="M8.3467 1.88L8.70003 2.58667C8.7467 2.68667 8.87336 2.78 8.98003 2.79333L9.62003 2.9C10.0267 2.96667 10.1267 3.26666 9.83336 3.55332L9.33336 4.05332C9.2467 4.13999 9.20003 4.3 9.2267 4.41333L9.3667 5.02667C9.48003 5.51334 9.22003 5.70001 8.79336 5.44667L8.19336 5.09334C8.0867 5.02668 7.9067 5.02668 7.80003 5.09334L7.20003 5.44667C6.77336 5.70001 6.51336 5.51334 6.6267 5.02667L6.7667 4.41333C6.79337 4.3 6.7467 4.13332 6.66003 4.05332L6.1667 3.56C5.87336 3.26666 5.9667 2.97332 6.38003 2.90666L7.02003 2.80001C7.1267 2.78001 7.25336 2.68668 7.30003 2.59334L7.65336 1.88666C7.8467 1.49999 8.15336 1.5 8.3467 1.88Z"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>

                <span className="m-1 menu-text ">{t("nav.news.main")}  </span>
              </p>
            </div>
          </nav>
        </div>
        <div className="nav__actions-container">
          <div className="socials">
            <a href="https://twitter.com/Susfchannel" _target="blank">
              <svg class="twitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>
              {/*             
              <svg
                className="twitter"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M22.2125 5.65605C21.4491 5.99375 20.6395 6.21555 19.8106 6.31411C20.6839 5.79132 21.3374 4.9689 21.6493 4.00005C20.8287 4.48761 19.9305 4.83077 18.9938 5.01461C18.2031 4.17106 17.098 3.69303 15.9418 3.69434C13.6326 3.69434 11.7597 5.56661 11.7597 7.87683C11.7597 8.20458 11.7973 8.52242 11.8676 8.82909C8.39047 8.65404 5.31007 6.99005 3.24678 4.45941C2.87529 5.09767 2.68005 5.82318 2.68104 6.56167C2.68104 8.01259 3.4196 9.29324 4.54149 10.043C3.87737 10.022 3.22788 9.84264 2.64718 9.51973C2.64654 9.5373 2.64654 9.55487 2.64654 9.57148C2.64654 11.5984 4.08819 13.2892 6.00199 13.6731C5.6428 13.7703 5.27232 13.8194 4.90022 13.8191C4.62997 13.8191 4.36771 13.7942 4.11279 13.7453C4.64531 15.4065 6.18886 16.6159 8.0196 16.6491C6.53813 17.8118 4.70869 18.4426 2.82543 18.4399C2.49212 18.4402 2.15909 18.4205 1.82812 18.3811C3.74004 19.6102 5.96552 20.2625 8.23842 20.2601C15.9316 20.2601 20.138 13.8875 20.138 8.36111C20.138 8.1803 20.1336 7.99886 20.1256 7.81997C20.9443 7.22845 21.651 6.49567 22.2125 5.65605Z"></path>
              </svg> */}
            </a>
            {/* <a href="https://www.instagram.com/susfchannel" _target="blank">
              <svg
                className="instagram"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"></path>
              </svg>
            </a> */}
            <a href="https://www.youtube.com/user/susfchannel" _target="blank">
              <svg
                className="youtube"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M16 12L10 18V6L16 12Z"></path>
              </svg>
            </a>
            {/* <a href="snapchat" _target="blank">
              <svg
                className="snapchat"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M11.872 21.7645C10.6817 21.7645 9.88811 21.2027 9.17926 20.7079C8.67548 20.3512 8.20292 20.0124 7.64564 19.9188C7.37369 19.8697 7.09729 19.8519 6.84317 19.8519C6.3706 19.8519 5.99612 19.9232 5.72863 19.9767C5.55922 20.0079 5.41655 20.0347 5.3051 20.0347C5.18919 20.0347 5.04207 20.0035 4.98411 19.8073C4.93507 19.6468 4.90386 19.4953 4.87266 19.3481C4.79241 18.9781 4.72554 18.7507 4.58733 18.7285C3.0983 18.5011 2.20667 18.1578 2.0328 17.7521C2.01942 17.7075 2.00159 17.6629 2.00159 17.6273C1.99267 17.5025 2.08184 17.3999 2.20667 17.3776C3.38808 17.1815 4.44913 16.5529 5.34522 15.5186C6.0407 14.7161 6.37952 13.9404 6.41073 13.8557C6.41073 13.8467 6.41964 13.8467 6.41964 13.8467C6.58906 13.4946 6.62472 13.1959 6.52218 12.9507C6.33048 12.4915 5.69742 12.2953 5.26498 12.1616C5.15352 12.1303 5.0599 12.0947 4.97965 12.0679C4.60962 11.9208 3.9944 11.6087 4.07464 11.1763C4.1326 10.8642 4.54721 10.6413 4.88603 10.6413C4.97965 10.6413 5.0599 10.6547 5.12677 10.6904C5.50572 10.8642 5.849 10.9534 6.14324 10.9534C6.50881 10.9534 6.68268 10.8152 6.72726 10.7706C6.71834 10.5744 6.70497 10.3694 6.69159 10.1777C6.60243 8.81346 6.49989 7.11936 6.93234 6.14747C8.22967 3.24074 10.9848 3.00892 11.8007 3.00892C11.823 3.00892 12.1573 3 12.1573 3C12.1707 3 12.1885 3 12.2064 3C13.0222 3 15.7774 3.22737 17.0747 6.13856C17.5116 7.11044 17.4046 8.80901 17.3154 10.1687L17.3065 10.2356C17.2976 10.4184 17.2842 10.5923 17.2753 10.7706C17.3199 10.8063 17.4804 10.94 17.8103 10.9445C18.0956 10.9356 18.4077 10.8419 18.7643 10.6814C18.8758 10.6324 18.9917 10.6146 19.0764 10.6146C19.2012 10.6146 19.3261 10.6458 19.4331 10.6814H19.442C19.7407 10.7929 19.9368 11.0024 19.9368 11.2209C19.9458 11.426 19.7853 11.738 19.0229 12.0456C18.9427 12.0768 18.849 12.1125 18.7376 12.1393C18.3141 12.2686 17.681 12.4736 17.4804 12.9284C17.3689 13.1691 17.4135 13.4767 17.5829 13.8245C17.5829 13.8334 17.5918 13.8334 17.5918 13.8334C17.6409 13.9582 18.9293 16.8828 21.7959 17.3598C21.9207 17.3821 22.001 17.4846 22.001 17.6094C22.001 17.654 21.9921 17.6986 21.9698 17.7387C21.7959 18.1489 20.9132 18.4833 19.4152 18.7151C19.277 18.7374 19.2102 18.9647 19.1299 19.3348C19.0987 19.4863 19.063 19.6335 19.0185 19.794C18.9739 19.9411 18.8803 20.0213 18.7198 20.0213H18.6975C18.5949 20.0213 18.4567 20.0079 18.2739 19.9723C17.953 19.9054 17.6008 19.8564 17.1594 19.8564C16.8964 19.8564 16.6244 19.8787 16.3569 19.9232C15.8041 20.0124 15.3271 20.3557 14.8233 20.7123C14.1055 21.2027 13.3075 21.7645 12.1261 21.7645C12.1261 21.7645 11.9077 21.7645 11.872 21.7645Z"></path>
              </svg>
            </a> */}
          </div>
          <div onClick={() => changeLanguage()} className="language">
            <img src={images.globe} alt="" />
            <span>{currentLang === "ar" || currentLang === undefined || !currentLang  ? "English" : "العربية"}</span>
          </div>
        </div>
      </div>
      {expandSubNav && (
        <div className="sub-nav">
          <ul>
            {subNav[activeTab].map((tab, index) =>
              tab.url !== undefined ? (
                <>
                  <li
                    className="subNav-item"
                    key={index}
                    onClick={() => window.open(tab.url, "_blank")}
                  >
                    <Link>
                      <img className="subNavIcon" src={tab.image} alt="" />
                      <span>{tab.label}</span>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="subNav-item" key={index}>
                    <NavLink
                      to={tab.path}
                      onClick={() => toggleSubNav(activeTab)}
                    >
                      <img src={tab.image} alt="" />
                      <span>{tab.label}</span>
                    </NavLink>
                  </li>
                </>
              )
            )}
          </ul>
        </div>
      )}
      {props.toggleMobileNav && (
        <div className="mobileNav">
          <img
            className="close-menu"
            src={images.close}
            onClick={() => {
              props.setToggleMobileNav(false);
            }}
            alt=""
          />
          <ul className="main-nav-list">
            {/* home */}
            <Link
              to="/"
              onClick={() => {
                props.setToggleMobileNav(false);
              }}
            >
              <li className="main-section">
                <p className="nav-link home">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="vuesax/linear/house-2">
                      <g id="vuesax/linear/house-2_2">
                        <g id="house-2">
                          <path
                            id="Vector"
                            d="M1.33337 15.1667H14.6667"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_2"
                            d="M1.96667 15.1667L2.00001 7.14668C2.00001 6.74001 2.19334 6.35338 2.51334 6.10005L7.18001 2.46671C7.66001 2.09337 8.33335 2.09337 8.82001 2.46671L13.4867 6.09338C13.8133 6.34671 14 6.73335 14 7.14668V15.1667"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_3"
                            d="M10.3333 7.83331H5.66663C5.11329 7.83331 4.66663 8.27998 4.66663 8.83331V15.1666H11.3333V8.83331C11.3333 8.27998 10.8866 7.83331 10.3333 7.83331Z"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_4"
                            d="M6.66663 11.3333V12.3333"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            id="Vector_5"
                            d="M7 5.5H9"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span className="m-1  menu-text">{t("nav.main")} </span>
                </p>
              </li>
            </Link>
            {/* etihad */}
            <li className="main-section">
              <p className="nav-link active">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="vuesax/linear/status-up">
                    <g id="vuesax/linear/status-up_2">
                      <g id="status-up">
                        <path
                          id="Vector"
                          d="M4.58667 12.6V11.22"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          id="Vector_2"
                          d="M8 12.6V9.84003"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          id="Vector_3"
                          d="M11.4133 12.6V8.45331"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          id="Vector_4"
                          d="M11.4133 4.40002L11.1067 4.76002C9.40667 6.74669 7.12667 8.15336 4.58667 8.78669"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          id="Vector_5"
                          d="M9.45996 4.40002H11.4133V6.34669"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_6"
                          d="M6.00004 15.1666H10C13.3334 15.1666 14.6667 13.8333 14.6667 10.5V6.49998C14.6667 3.16665 13.3334 1.83331 10 1.83331H6.00004C2.66671 1.83331 1.33337 3.16665 1.33337 6.49998V10.5C1.33337 13.8333 2.66671 15.1666 6.00004 15.1666Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
                <span className="m-1  menu-text">{t("nav.ethad.main")} </span>
              </p>
              <ul className="sub-section">
                <li>
                  <Link
                    to="etihad/AboutEtihad"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.aboutEtihad} alt="" />
                    <span>{t("nav.ethad.about")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="etihad/Leader"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.ethiad_card} alt="" />
                    <span>{t("nav.ethad.chef")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="etihad/ManagerialStructure"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.ethiad_org} alt="" />
                    <span>{t("nav.ethad.structure")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="etihad/Law"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.profile} alt="" />
                    <span>{t("nav.ethad.law")}</span>
                  </Link>
                </li>
              </ul>
            </li>
            {/* compitions */}
            <li className="main-section">
              <p className="nav-link">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="vuesax/linear/cup">
                    <g id="vuesax/linear/cup_2">
                      <g id="cup">
                        <path
                          id="Vector"
                          d="M8.09998 11.5V12.9"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_2"
                          d="M4.76672 15.1667H11.4334V14.5C11.4334 13.7667 10.8334 13.1667 10.1001 13.1667H6.10006C5.36672 13.1667 4.76672 13.7667 4.76672 14.5V15.1667V15.1667Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                        />
                        <path
                          id="Vector_3"
                          d="M4.09998 15.1667H12.1"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_4"
                          d="M8.00004 11.1666C5.42004 11.1666 3.33337 9.07998 3.33337 6.49998V4.49998C3.33337 3.02665 4.52671 1.83331 6.00004 1.83331H10C11.4734 1.83331 12.6667 3.02665 12.6667 4.49998V6.49998C12.6667 9.07998 10.58 11.1666 8.00004 11.1666Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_5"
                          d="M3.64665 8.26669C3.14665 8.10669 2.70665 7.81336 2.35999 7.46669C1.75999 6.80002 1.35999 6.00002 1.35999 5.06669C1.35999 4.13336 2.09332 3.40002 3.02665 3.40002H3.45999C3.32665 3.70669 3.25999 4.04669 3.25999 4.40002V6.40002C3.25999 7.06669 3.39999 7.69336 3.64665 8.26669Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_6"
                          d="M12.3534 8.26669C12.8534 8.10669 13.2934 7.81336 13.6401 7.46669C14.2401 6.80002 14.6401 6.00002 14.6401 5.06669C14.6401 4.13336 13.9067 3.40002 12.9734 3.40002H12.5401C12.6734 3.70669 12.7401 4.04669 12.7401 4.40002V6.40002C12.7401 7.06669 12.6001 7.69336 12.3534 8.26669Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
                <Link
                  to="competitions"
                  onClick={() => {
                    props.setToggleMobileNav(false);
                  }}
                >
                  <span className="m-1  menu-text">{t("nav.competion")} </span>
                </Link>
              </p>
            </li>
            {/* e services */}
            <li className="main-section">
              <p className="nav-link ">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    id="services-20px-svgrepo-com 1"
                    clipPath="url(#clip0_1_5799)"
                  >
                    <g id="Group">
                      <path
                        id="Vector"
                        d="M0.800049 15.2H4.00005V12H0.800049V15.2ZM6.40005 15.2H9.60005V12H6.40005V15.2ZM12 15.2H15.2V12H12V15.2ZM0.800049 9.59999H4.00005V6.39999H0.800049V9.59999ZM6.40005 9.59999H9.60005V6.39999H6.40005V9.59999ZM12 9.59999H15.2V6.39999H12V9.59999ZM0.800049 3.99999H4.00005V0.799988H0.800049V3.99999ZM6.40005 3.99999H9.60005V0.799988H6.40005V3.99999ZM12 0.799988V3.99999H15.2V0.799988H12Z"
                        fill="#647687"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_1_5799">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <span className="m-1  menu-text">{t("nav.otherServices.main")} </span>
              </p>
              <ul className="sub-section">
                {/* <li>
                  <Link to="https://nashtsport.com">
                    <img src={images.group} alt="" />
                    <span>{t("nav.otherServices.nashet")}</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="https://admin.susfweb.com/login?lt=1">
                    <img src={images.gear} alt="" />
                    <span>{t("nav.otherServices.ahlia")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="https://admin.susfweb.com/login?lt=3">
                    <img src={images.status} alt="" />
                    <span>{t("nav.otherServices.result")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="https://admin.susfweb.com/login?lt=2">
                    <img src={images.trophy} alt="" />
                    <span>{t("nav.otherServices.competition")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="https://susftask.com">
                    <img src={images.briefcase} alt="" />
                    <span>{t("nav.otherServices.tasks")}</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="https://outlook.office.com/owa/?realm=susfweb.com">
                    <img src={images.email} alt="" />
                    <span>{t("nav.otherServices.email")}</span>
                  </Link>
                </li>
              </ul>
            </li>
            {/* media */}
            <li className="main-section">
              <p className="nav-link">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="vuesax/linear/ranking">
                    <g id="vuesax/linear/ranking_2">
                      <g id="ranking">
                        <path
                          id="Vector"
                          d="M5.78004 9.83331H2.66671C1.93337 9.83331 1.33337 10.4333 1.33337 11.1666V15.1666H5.78004V9.83331Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_2"
                          d="M8.88665 7.16669H7.10665C6.37332 7.16669 5.77332 7.76669 5.77332 8.50002V15.1667H10.22V8.50002C10.22 7.76669 9.62665 7.16669 8.88665 7.16669Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          id="Vector_3"
                          d="M13.3333 11.8333H10.22V15.1666H14.6666V13.1666C14.6666 12.4333 14.0666 11.8333 13.3333 11.8333Z"
                          stroke="#4E6276"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <g id="Group">
                          <path
                            id="Vector_4"
                            d="M8.3467 1.88L8.70003 2.58667C8.7467 2.68667 8.87336 2.78 8.98003 2.79333L9.62003 2.9C10.0267 2.96667 10.1267 3.26666 9.83336 3.55332L9.33336 4.05332C9.2467 4.13999 9.20003 4.3 9.2267 4.41333L9.3667 5.02667C9.48003 5.51334 9.22003 5.70001 8.79336 5.44667L8.19336 5.09334C8.0867 5.02668 7.9067 5.02668 7.80003 5.09334L7.20003 5.44667C6.77336 5.70001 6.51336 5.51334 6.6267 5.02667L6.7667 4.41333C6.79337 4.3 6.7467 4.13332 6.66003 4.05332L6.1667 3.56C5.87336 3.26666 5.9667 2.97332 6.38003 2.90666L7.02003 2.80001C7.1267 2.78001 7.25336 2.68668 7.30003 2.59334L7.65336 1.88666C7.8467 1.49999 8.15336 1.5 8.3467 1.88Z"
                            stroke="#4E6276"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>

                <span className="m-1 menu-text ">{t("nav.news.main")} </span>
              </p>
              <ul className="sub-section">
                <li>
                  <Link
                    to="mediaCenter/News"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.message} alt="" />
                    <span>{t("nav.news.news")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="mediaCenter/Activities"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.scissor} alt="" />
                    <span>{t("nav.news.events")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="mediaCenter/Videos"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.media} alt="" />
                    <span>{t("nav.news.vidios")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="mediaCenter/Photos"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.gallery} alt="" />
                    <span>{t("nav.news.images")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="mediaCenter/Advertisements"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.ads} alt="" />
                    <span>{t("nav.news.ads")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="mediaCenter/MediaFiles"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.profile} alt="" />
                    <span>{t("nav.news.media")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="mediaCenter/Prints"
                    onClick={() => {
                      props.setToggleMobileNav(false);
                    }}
                  >
                    <img src={images.printer} alt="" />
                    <span>{t("nav.news.prints")}</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Nav;
